var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSqlBuilder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-289 381 32 32",
    style: {
      enableBackground: "new -289 381 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#74B1E0;}\n\t.st1{fill:#CDE4F7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-275.4,391.4c-6.2,0-12.7-1.7-12.7-4.8c0-3.2,6.4-4.8,12.7-4.8c6.3,0,12.7,1.6,12.7,4.8 C-262.7,389.7-269.2,391.4-275.4,391.4z M-275.4,383.3c-7,0-11.2,1.9-11.2,3.3s4.3,3.3,11.2,3.3c7,0,11.2-1.9,11.2-3.3 S-268.4,383.3-275.4,383.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-275.4,398.3c-6.2,0-12.7-1.7-12.7-4.8h1.5c0,1.4,4.3,3.3,11.2,3.3c7,0,11.2-1.9,11.2-3.3h1.5 C-262.7,396.6-269.2,398.3-275.4,398.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-275.4,405.2c-6.2,0-12.7-1.7-12.7-4.8h1.5c0,1.4,4.3,3.3,11.2,3.3c0.9,0,1.7,0,2.5-0.1l0.1,1.5 C-273.6,405.2-274.5,405.2-275.4,405.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-275.4,412.2c-6.2,0-12.7-1.7-12.7-4.8v-20.8h1.5c0,1.4,4.3,3.3,11.2,3.3c7,0,11.2-1.9,11.2-3.3h1.5v11.3 h-1.5v-9c-2.3,1.6-6.9,2.4-11.2,2.4c-4.4,0-8.9-0.8-11.2-2.4v18.5c0,1.4,4.3,3.3,11.2,3.3c2.3,0,4.5-0.2,6.5-0.7l0.3,1.5 C-270.6,411.9-273,412.2-275.4,412.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258.6,404.5c0,3.9-3.1,7-7,7s-7-3.1-7-7s3.1-7,7-7C-261.8,397.5-258.6,400.6-258.6,404.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-265.6,412.3c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8c4.3,0,7.8,3.5,7.8,7.8 C-257.9,408.8-261.4,412.3-265.6,412.3z M-265.6,398.2c-3.4,0-6.3,2.8-6.3,6.3c0,3.4,2.8,6.3,6.3,6.3c3.4,0,6.3-2.8,6.3-6.3 C-259.4,401-262.2,398.2-265.6,398.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-265.6,406.5 -268.2,408 -267.5,405.1 -269.7,403.2 -266.8,402.9 -265.6,400.2 -264.5,402.9  -261.5,403.2 -263.8,405.1 -263.1,408  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-268.2,408.7c-0.2,0-0.3,0-0.4-0.1c-0.2-0.2-0.4-0.5-0.3-0.8l0.6-2.4l-1.9-1.6c-0.2-0.2-0.3-0.5-0.2-0.8 s0.3-0.5,0.6-0.5l2.5-0.2l1-2.3c0.1-0.3,0.4-0.5,0.7-0.5l0,0c0.3,0,0.6,0.2,0.7,0.5l1,2.3l2.5,0.2c0.3,0,0.6,0.2,0.6,0.5 c0.1,0.3,0,0.6-0.2,0.8l-1.9,1.6l0.6,2.4c0.1,0.3,0,0.6-0.3,0.8c-0.2,0.2-0.6,0.2-0.8,0l-2.1-1.3l-2.1,1.3 C-267.9,408.7-268,408.7-268.2,408.7z M-267.9,403.8l0.9,0.8c0.2,0.2,0.3,0.5,0.2,0.7l-0.2,1.1l1-0.6c0.2-0.1,0.5-0.1,0.8,0l1,0.6 l-0.3-1.1c-0.1-0.3,0-0.6,0.2-0.7l0.9-0.8l-1.2-0.1c-0.3,0-0.5-0.2-0.6-0.5l-0.5-1.1l-0.5,1.1c-0.1,0.3-0.3,0.4-0.6,0.5 L-267.9,403.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlBuilder);
export default __webpack_public_path__ + "static/media/sql_builder.6bf407a75b2cfdceca2d30c0be652d0e.svg";
export { ForwardRef as ReactComponent };